import React from "react";
import { MdClose } from "react-icons/md";
import { useTranslation } from "react-i18next";

const ActiveFilters = ({
  filters,
  onClearAll,
  extraActiveCount = 0,
  showClearAll = true,
}) => {
  const { t } = useTranslation("common");
  const totalActive = (filters?.length ?? 0) + extraActiveCount;
  if (!totalActive) return null;

  return (
    <div className="flex min-w-0 items-center gap-[6px] overflow-x-auto scrollbar-hide">
      {filters?.map(({ key, label, value, onRemove }) => (
        <span
          key={key}
          className="inline-flex max-w-[200px] shrink-0 items-center gap-1 rounded-full bg-brand-light px-2 py-[3px] text-[11px] font-medium text-brand"
        >
          <span className="truncate">
            {label}: {value}
          </span>
          <button
            type="button"
            onClick={onRemove}
            aria-label={t("table.removeFilter", { name: label })}
            className="shrink-0 opacity-60 transition-opacity hover:opacity-100"
          >
            <MdClose className="h-3 w-3" />
          </button>
        </span>
      ))}

      {showClearAll && totalActive > 1 && (
        <button
          type="button"
          onClick={onClearAll}
          className="shrink-0 whitespace-nowrap rounded-full px-2 py-[3px] text-[11px] text-ui-text-muted transition-colors hover:bg-state-danger-bg hover:text-state-danger-text"
        >
          {t("actions.clearAll")}
        </button>
      )}
    </div>
  );
};

export default ActiveFilters;
